import { getIdOrNull } from '..'
import apiClient from './apiClient'

export const consumeTracker = (tracker) => apiClient.patch(null, `api/trackers/${getIdOrNull(tracker)}/is-consumed`, {})
